/**
 * @returns {React.JSX.Element}
 */
export function PlusIcon() {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
      <path d="M6.5 0.5V11.5M1 6H12H1Z" strokeWidth="2" />
    </svg>
  );
}
